import { z } from "zod";

import { branded } from "@/utils/branded-validation-utils";
import { ECountryCode } from "@/utils/country";
import { CustomValidators } from "@/utils/validators";

export const geolocatedSiteAddressSchema = z.object({
  rawAddress: z.string().nullish(),
  streetNumber: z.string().nullish(),
  street: z.string(),
  complement: z.string().nullish(),
  postalCode: z.string(),
  city: z.string(),
  cityCode: z.string().nullish(),
  latitude: z.number(),
  longitude: z.number(),
  score: z.number().nullish(),
  context: z.string().nullish(),
  timeZone: CustomValidators.zodTimeZone(z.string()),
});

export const postalSiteAddressSchema = z.object({
  streetNumber: z.string().nullable(),
  street: z.string().nullable(),
  complement: z.string().nullable(),
  postalCode: z.string().nullable(),
  city: z.string().nullable(),
});

export const siteAddressSchema = z.object({
  geolocatedSiteAddress: geolocatedSiteAddressSchema,
  postalSiteAddress: postalSiteAddressSchema.nullable(),
  countryIsoCode: z.string().transform((k) => k as ECountryCode), // cast it to country code
});

export const siteSchema = z.object({
  siteId: branded.v4hSiteId,
  name: z.string(),
  parentAdministrationDivisionId: z.number().nullish(),
  parentAdministrationDivisionName: z.string().nullish(),
  organizationId: z.number().nullish(),
  organizationName: z.string().nullish(),
  siteAddressDto: siteAddressSchema,
  programingIsSuspended: z.boolean(),
});

export const sitesResponseSchema = z.array(siteSchema);

export type TGeolocatedSiteAddress = z.infer<typeof geolocatedSiteAddressSchema>;
export type TPostalSiteAddress = z.infer<typeof postalSiteAddressSchema>;
export type TSite = z.infer<typeof siteSchema>;

export const siteDetailsResponseSchema = z.object({
  name: z.string(),
  siteId: branded.v4hSiteId,
  address: siteAddressSchema,
});

export type TSiteDetails = z.infer<typeof siteDetailsResponseSchema>;
export type TSiteAddress = z.infer<typeof siteAddressSchema>;
